// extracted by mini-css-extract-plugin
export default {"breadcrumbContainer":"BreadcrumbRow_breadcrumbContainer__g0a9E","width":"BreadcrumbRow_width__prkuW","Breadcrumb":"BreadcrumbRow_Breadcrumb__KyTjn"};